<template>
  <div class="prodetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <div class="card">
      <ul>
        <li>
          <h3>{{proDetail.title}}</h3>
          <div class="price"><font>售<i style="opacity:0">场</i>价：</font>￥{{proDetail.rate}}</div>
          <div class="rate"><font>市场价：</font><span style="text-decoration: line-through">￥{{proDetail.price}}</span></div>
        </li>
      </ul>

      <div class="user">
        <div style="height:90px">
          <div class="left">
          <span><i>*</i>联系人</span>
          <input style="width:60%" readonly="" type="text" :value="name" />
          <span><i>*</i>证件号</span>
          <input style="width:60%" readonly="" type="text"  :value="idCard" />
          </div>
          <form class="right" @click="getQquey">
            <label for="file-input">
              <img src="~assets/images/ppp.png" />
            </label>
            <a>身份证拍照识别</a>
          </form>
        </div>
        <div>
          <span><i>*</i>手机号</span>
          <input type="text" @input="codeYzm" placeholder="请输入手机号码" v-model="phone" />
          <font @click="send" :style="pat ? 'color:#000' : ''">{{sendSns}}</font>
        </div>
        <div>
          <span><i>*</i>验证码</span>
          <input type="text" placeholder="请输入短信验证码" v-model="code" />
        </div>
      </div>

      <dl>
        <dt>包含门票</dt>
        <dd class="curt">
          <span>景点名称</span>
          <font>数量</font>
        </dd>
        <dd v-for="(item,i) in card">
          <span>{{item.title}}</span>
          <font>{{item.num}}</font>
        </dd>
      </dl>
    </div>
    <div style="height:52px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>1件商品</span>
        <span>￥{{proDetail.rate}}</span>
      </div>
      <div class="pay" @click="payment">
        <span>立即购买</span>        
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proDetail:[],
        card:[],
        userData:[],
        phone:'',
        name:'',  
        idCard:'',      
        sendSns:'获取验证码',
        pat:false,
        flag: false,
        code:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                              that.getAjax(res.localData.replace('data:image/jpeg/png;base64,',''))
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/user/sfCard',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.idCard = msg.data.num,
              that.name = msg.data.name
            }else{
              alert('身份证识别失败！');
            }
            that.fullscreenLoading = false;
          }
        })
      },

      codeYzm:function(){
        let reg = /^1[0-9]{10}$/;
        var phone = this.phone;
        if (reg.test(phone)){
          this.pat = true
        }else{
          this.pat = false
        }
      },
      send:function(){
        if(!this.pat || this.flag){
          return false;
        }
        if(this.phone == ''){
          alert('请输入手机号码');
          return false;
        }
        let reg = /^1[0-9]{10}$/
        if(!reg.test(this.phone)){
          alert('请输入正确的手机号码');
          return false;
        }
        var i = 60
        let time = setInterval(() => {
          i--
          if(i < 1){
            this.sendSns = '获取验证码';
            clearInterval(time)
            this.pat = false;
            this.flag = false
            return false;
          }
          this.sendSns = i+'秒后重试';
          this.flag = true
          }, 1000)

        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/SendSms',
          params:{
            phone:that.phone
          }
        }).then(function(response){
          if(response.data.status == 200){

          }else{
            alert('短信下发失败');
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      payment:function(){
        var that = this;
        if(that.name == ''){
          alert('请识别身份信息！');
          return false;
        }
        if(that.phone == ''){
          alert('请输入手机号！');
          return false;
        }
        if(that.code == ''){
          alert('请输入手机验证码！');
          return false;
        }
        var id = this.$route.query.id;

        that.axios({
          method:'post',
          url:that.$host+'home/order/weixinPay',
          params:{
            id:id,
            user_id:that.userData.id,
            phone:that.phone,
            code:that.code,
            name:that.name,
            idCard:that.idCard,
            pay_money:that.proDetail.rate
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }else{
            alert('验证码无效');
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/order?id=2";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      getDetail:function(){
        var id = this.$route.query.id;
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/payOrder',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;

          that.proDetail = res.rs;
          that.card = res.card;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .prodetailApp{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
  }

  .prodetailApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
  }
  .prodetailApp .card ul li{
    width:100%;
    margin-bottom:8px;
    position:relative;
  }
  .prodetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1.5px
  }

  .prodetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#007aff;
    letter-spacing:1px;
  }
  .prodetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    letter-spacing:1px;
    color:#333
  }
  .prodetailApp .card ul li .price font{
    color:#333;
    font-size:15px
  }

  .prodetailApp .card .user{
    display:block;
    width:100%;
    background:#fff;
    margin-top:8px;
  }
  .prodetailApp .card .user div{
    width:100%;
    display:block;
    border-bottom:solid 1px #f1f1f1;
    height:45px;
  }
  .prodetailApp .card .user div span{
    float:left;
    width:25%;
    margin-left:10px;
    height:45px;
    line-height:45px;
    font-size:15px;
    letter-spacing:1px;
  }
  .prodetailApp .card .user .left{
    float:left;
    width:75%;
  }
  .prodetailApp .card .user div input{
    float:left;
    width:40%;
    height:45px;
    line-height:45px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    margin-left:3%
  }
  .prodetailApp .card .user div font{
    float:left;
    font-size:14px;
    background:#f1f1f1;
    padding:6px 10px;
    margin-top:8px;
    color:#666;
    border-radius:4px;
  }
  .prodetailApp .card .user div i{
    color:#f00;
    font-size:20px;
    padding-right:5px;
    font-weight:bold;
    position:relative;
    top:5px
  }
  
  .prodetailApp .card dl{
    display:block;
    width:100%;
    background:#fff;
    margin-top:8px;
  }
  .prodetailApp .card dl dt{
    font-size:16px;
    font-weight:bold;
    border-bottom:solid 1px #f1f1f1;
    padding:0px 20px;
    height:40px;
    line-height:40px;
    letter-spacing:1px;
  }
  .prodetailApp .card dl dd{
    padding:0px 20px;
    height:40px;
    line-height:40px;
    border-bottom:solid 1px #f1f1f1;
  }
  .prodetailApp .card dl dd span{
    float:left;
    width:80%;
    height:40px;
    line-height:40px;;
    font-size:15px;
    letter-spacing:1px
  }
  .prodetailApp .card dl dd.curt span{
    font-weight:bold;
  }

  .prodetailApp .card dl dd font{
    float:right;
    background:#007aff;
    height:22px;
    line-height:22px;
    color:#fff;
    border-radius:20px;
    padding:0 8px;
    margin-top:9px;
    font-size:14px
  }
  .prodetailApp .card dl dd.curt font{
    background:green;
  }

  .footer1{
    height: 50px;
    background: #fff;
    width: 100%;
    box-shadow:0px 0px 20px 0px rgba(102,102,102,0.3);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999
  }
  .prodetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    margin-top: 8px;
  }
  .prodetailApp .footer1 .foot-title span{
    display: block;
    font-size: 12px;
    color: #727272;
    text-align:center;
  }
  .prodetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 2%;
    margin-top:5px;
    width:60%
  }
  .prodetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #fa0024;
    border-radius:40px;
  }


  .prodetailApp .right{
    float:right;
    width:25%;
    text-align:right;
    font-size:10px;
    position:relative
  }
  .prodetailApp .right:after{
    content:'';
    height:60px;
    width:1px;
    background:#f1f1f1;
    position:absolute;
    left:0px;
    top:20%;
  }
  .prodetailApp .right img{
    display:block;
    width:30px;
    height:30px;
    margin:0 auto;
    margin-bottom:5px;
    margin-top:15px
  }
  .prodetailApp .right a{
    display:block;
    text-align:center;
  }
  .prodetailApp .right > input{
    display: none;
  }

 
</style>